import { Modal } from 'antd';

import styled from 'styled-components';

export const AlertBox = styled(Modal)`
  .ant-modal-body {
    overflow-y: auto;
  }

  .ant-modal-content {
    border-radius: 16px;
  }

  .ant-modal-footer button {
    width: 100% !important;
    height: 32px;
    &.okBtn {
      background: #2d3f86;
      > span {
        color: #fff;
      }
    }
  }

  & > div:nth-child(1) {
    margin-top: 50%;
  }
`;
